import PropTypes from 'prop-types';
import Field from '@base/Form/Field';
import { useEffect, useState } from 'react';
import {
  FormSectionHeading,
  StyledDropdown,
  FieldWrapper
} from '@cont/OfflineCentres/PostPaymentLearnerDetails/styles';
import { FormContainer } from '@cont/BookScholarshipSchool/styles';
import RadioButton from '@base/RadioButton/RadioButton';
import useWindowSize from '@hooks/useWindowSize';
import {
  examAndClasses,
  getCentres,
  getCities,
  radioOptions
} from './constants';
import { Error, RadioWrapper, RadioCardWrapper, StyledTextP1 } from './styles';
import { isRequired } from './utils';

const renderErrorMessage = ({ message }) => {
  return <Error>{message}</Error>;
};

const TestDetails = ({
  registrar,
  cityCenterMapping,
  dateSlots,
  setIsOnlineSelected,
  isOnlineSelected
}) => {
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [centreOptions, setCentreOptions] = useState([]);
  const [isOfflineDisabled, setIsOfflineDisabled] = useState(false);
  useEffect(() => {
    setCitiesOptions(getCities(cityCenterMapping));
  }, [cityCenterMapping]);
  const { setData, data: registrarData } = registrar;

  useEffect(() => {
    const centres = getCentres(cityCenterMapping, registrar?.data?.city);
    setCentreOptions(centres);
  }, [registrar.data.city, cityCenterMapping, setData]);

  const updateCenter = (updatedCity) => {
    const centres = getCentres(cityCenterMapping, updatedCity);
    setCentreOptions(centres);
    setData('centerName', centres[0]);
  };
  const { isMobile } = useWindowSize();
  const updateOfflineRadio = (testTypeData = {}) => {
    const { disabledOfflineForSlot } = testTypeData;
    if (disabledOfflineForSlot) {
      setIsOnlineSelected(true);
      setData('centerName', '');
      setData('city', '');
      setData('testType', radioOptions[1]);
      setIsOfflineDisabled(true);
      return;
    }
    setIsOfflineDisabled(false);
  };

  const checkIsOfflineDisable = (dateAndTime) => {
    const selectedSlot = dateSlots.find((slot) => slot?.id === dateAndTime?.id);
    if (selectedSlot) updateOfflineRadio(selectedSlot);
  };
  useEffect(() => {
    const { dateAndTime } = registrarData;
    if (dateAndTime) checkIsOfflineDisable(dateAndTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registrarData?.dateAndTime]);

  return (
    <FormContainer>
      <>
        <FormSectionHeading>Test details</FormSectionHeading>
        <FieldWrapper>
          <Field
            registrar={registrar}
            name="examAndClass"
            rules={[isRequired('Exam & class is required')]}
            render={({ onChange, value }) => (
              <StyledDropdown
                options={examAndClasses}
                placeholder="Select your exam & class"
                selectedOption={value}
                onOptionClick={(data) => onChange(data)}
                buttonWidth="100%"
              />
            )}
            renderError={renderErrorMessage}
          />
        </FieldWrapper>

        <FieldWrapper>
          <StyledTextP1>How do you want to take the test?</StyledTextP1>
          <Field
            registrar={registrar}
            name="testType"
            render={({ onChange }) => {
              return (
                <RadioCardWrapper>
                  {radioOptions.map((type) => {
                    const { data } = registrar;
                    const isDisabled =
                      type.id === radioOptions[0].id && isOfflineDisabled;
                    const isChecked = isDisabled
                      ? false
                      : data.testType?.id === type.id;
                    return (
                      <RadioWrapper
                        $checked={isChecked}
                        key={type.id}
                        $isDisabled={isDisabled}
                        onClick={() => {
                          if (!isDisabled) {
                            onChange(type);
                            setIsOnlineSelected(type.id === radioOptions[1].id);
                          }
                        }}
                      >
                        <RadioButton
                          checked={isChecked}
                          disabled={isDisabled}
                          label={type.label}
                        />
                      </RadioWrapper>
                    );
                  })}
                </RadioCardWrapper>
              );
            }}
            renderError={renderErrorMessage}
          />
        </FieldWrapper>
        {!isOnlineSelected ? (
          <>
            <FieldWrapper>
              <Field
                registrar={registrar}
                name="city"
                rules={[isRequired('City is required')]}
                render={({ onChange, value }) => (
                  <StyledDropdown
                    options={citiesOptions}
                    placeholder="Select city for test"
                    selectedOption={value}
                    onOptionClick={(data) => {
                      onChange(data);
                      updateCenter(data);
                    }}
                    buttonWidth="100%"
                  />
                )}
                renderError={renderErrorMessage}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Field
                registrar={registrar}
                name="centerName"
                rules={[isRequired('Centre is required')]}
                render={({ onChange, value }) => (
                  <StyledDropdown
                    options={centreOptions}
                    placeholder="Select a centre"
                    selectedOption={value}
                    onOptionClick={(data) => onChange(data)}
                    buttonWidth="100%"
                    menuWidth={centreOptions.length > 0 ? 'auto' : '233px'}
                    stripLength={isMobile ? 40 : null}
                  />
                )}
                renderError={renderErrorMessage}
              />
            </FieldWrapper>
          </>
        ) : null}

        <FieldWrapper>
          <StyledTextP1>Preferred date & time for test</StyledTextP1>
          <Field
            registrar={registrar}
            name="dateAndTime"
            rules={[isRequired('Date & time is required')]}
            render={({ onChange, value }) => (
              <StyledDropdown
                options={dateSlots}
                placeholder="Select date & time"
                selectedOption={value}
                onOptionClick={(data) => {
                  updateOfflineRadio(data);
                  onChange(data);
                }}
                buttonWidth="100%"
                menuWidth="auto"
              />
            )}
            renderError={renderErrorMessage}
          />
        </FieldWrapper>
      </>
    </FormContainer>
  );
};

TestDetails.propTypes = {
  registrar: PropTypes.objectOf(PropTypes.any).isRequired
};

export default TestDetails;
